export const Color = {
  PRIMARY: '#03045e',
  SECONDARY: '#023e8a',
  TERTIARY: '#0077b6',
};
